import { isApiError } from './errors.js';

export const FEATURE_NOT_IN_PLAN_CODE = 'FEATURE_NOT_IN_PLAN';

export interface FeatureDeniedInfo {
  feature: string | null;
  requiredFeatures: string[];
  path: string | null;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function isFeatureNotInPlan(data: unknown, status: number | null): boolean {
  return status === 403 && isRecord(data) && data.code === FEATURE_NOT_IN_PLAN_CODE;
}

export function parseFeatureDenied(data: unknown, status: number | null): FeatureDeniedInfo | null {
  if (!isFeatureNotInPlan(data, status) || !isRecord(data)) return null;
  return {
    feature: typeof data.feature === 'string' ? data.feature : null,
    requiredFeatures: Array.isArray(data.requiredFeatures)
      ? data.requiredFeatures.filter((feature): feature is string => typeof feature === 'string')
      : [],
    path: typeof data.path === 'string' ? data.path : null,
  };
}

export function isFeatureNotInPlanError(error: unknown): boolean {
  return isApiError(error) && isFeatureNotInPlan(error, error.statusCode);
}

export const FEATURE_DENIED_DEDUPE_MS = 5000;

/**
 * Dedupe de aviso por feature: duas negações da mesma feature em `windowMs` geram UM aviso.
 * Puro (relógio injetável) para os apps que mostram o aviso no interceptor (admin, studio, generative).
 */
export function createFeatureDeniedDedupe(windowMs: number = FEATURE_DENIED_DEDUPE_MS, now: () => number = Date.now) {
  const lastSeen = new Map<string, number>();
  return {
    shouldNotify(feature: string | null): boolean {
      const key = feature ?? '';
      const at = now();
      const previous = lastSeen.get(key);
      if (previous !== undefined && at - previous < windowMs) return false;
      lastSeen.set(key, at);
      return true;
    },
    reset(): void {
      lastSeen.clear();
    },
  };
}
